import { DateTime } from 'luxon';

export enum MetadataEntityFilterType {
    Flag = 'Flag',
    AutoComplete = 'AutoComplete',
    List = 'List',
    Calendar = 'Calendar',
    RelativeDate = 'RelativeDate',
    Time = 'Time',
    Number = 'Number',
}

type MetadataEntityFieldFilterBaseOptions = {
    preventClear?: boolean;
    readonly?: boolean;
}

export type MetadataEntityFieldTypeDate = {
    type: MetadataEntityFilterType.Calendar | MetadataEntityFilterType.RelativeDate | MetadataEntityFilterType.Time,
    options?: MetadataEntityFieldFilterBaseOptions & {
        showTime?: boolean;
        timezone?: string;

        /** Min Date, you probably want to set this in code at run time */
        minDate?: Date | DateTime | (() => Date | DateTime);

        /** Max Date, you probably want to set this in code at run time */
        maxDate?: Date | DateTime | (() => Date | DateTime);
    }
}

export type MetadataEntityFieldTypeString = {
    type: MetadataEntityFilterType.AutoComplete,
    options?: MetadataEntityFieldFilterBaseOptions & {
        singleSelect?: boolean,
    }
}

export type MetadataEntityFieldTypeNumber = {
    type: MetadataEntityFilterType.Number,
    options?: MetadataEntityFieldFilterBaseOptions
}

export type MetadataEntityFieldTypeFlag = {
    type: MetadataEntityFilterType.Flag,
    options?: MetadataEntityFieldFilterBaseOptions
}

export type MetadataEntityFieldTypeList = {
    type: MetadataEntityFilterType.List,
    options?: MetadataEntityFieldFilterBaseOptions & {
        singleSelect?: boolean,
    }
}

export type MetadataEntityFieldFilterOptions =
    MetadataEntityFieldTypeFlag |
    MetadataEntityFieldTypeDate |
    MetadataEntityFieldTypeString |
    MetadataEntityFieldTypeNumber |
    MetadataEntityFieldTypeList;